import MerchantCard from "./MerchantCard";
import { useGetBranchesQuery } from "@/store/api/branchApi";
import PageLoader from "../ui/PageLoader";
import { useFilter } from "@/contexts/FilterContext";

const MerchantList: React.FC = () => {
  const { businessType } = useFilter();
  const {
    data: branches,
    isLoading: isLoadingBranches,
    isError: isBranchError,
  } = useGetBranchesQuery();

  if (isBranchError) {
    return (
      <div className="text-center py-16">
        <h1 className="text-2xl">Failed to fetch branches</h1>
      </div>
    );
  }

  // Filter branches based on business type
  const filteredBranches = branches?.filter(
    (branch) => businessType === "All" || branch.business_type === businessType,
  );

  return (
    <PageLoader isFetching={isLoadingBranches}>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold text-center mb-8">
          <span className="text-red-600">LOVED</span> by best spots in your area
        </h1>
        {businessType !== "All" && (
          <h2 className="text-xl text-center mb-6">
            Showing {businessType} Locations
          </h2>
        )}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {filteredBranches?.map((branch) => (
            <div key={branch.id} className="flex flex-col items-center">
              <div className="p-4 bg-white rounded-lg shadow-md h-24 md:h-32 w-full">
                <MerchantCard key={branch.id} merchant={branch} />
              </div>
              <p className="font-bold mt-2 h-12 flex items-center text-center">
                {branch.name}
              </p>
            </div>
          ))}
        </div>
        {filteredBranches?.length === 0 && (
          <div className="text-center py-8">
            <p className="text-lg text-gray-600">
              No {businessType} locations found
            </p>
          </div>
        )}
      </div>
    </PageLoader>
  );
};

export default MerchantList;
